<template>
  <section style="height: 75vh" class="bg-default section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row mt-5 justify-content-center text-center text-white">
        <div class="col-lg-10">
          <h1 class="text-white font-weight-700">404 - Página não encontrada</h1>
          <p class="mb-0">Para acessar o novo portal Janela Única, acesse o link:</p>
          <a href="/">https://www.janelaunica.com.br</a>
          <br>
          <small>
            Qualquer dúvida entre em contato pelo chat onLine ou pelo e-mail suporte@maiatecnologia.com.br
          </small>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {}
</script>

